/**
 * AuditLog React Query hooks.
 *
 * search: 30s stale, refetches on filter change.
 * detail: long stale (audit entries are immutable).
 */
import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { auditLogService } from "@/services/auditLogService";
import type { AuditLogSearchFilters } from "@/types/auditLog.types";

const NS = ["audit-log"] as const;

export function useAuditLogSearch(
  filters: AuditLogSearchFilters,
  opts: { enabled?: boolean } = {},
) {
  return useQuery({
    queryKey: [...NS, "search", filters],
    queryFn: () => auditLogService.search(filters),
    enabled: opts.enabled ?? true,
    placeholderData: keepPreviousData,
    staleTime: 30_000,
    refetchOnWindowFocus: false,
  });
}

export function useAuditLogEntry(id: string | null) {
  return useQuery({
    queryKey: [...NS, "entry", id],
    queryFn: () => {
      if (!id) throw new Error("id required");
      return auditLogService.getById(id);
    },
    enabled: Boolean(id),
    // Entries are immutable; aggressive caching is safe
    staleTime: 10 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
}
